import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-779af610"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "antialiased text-gray-700 bg-gray-100" }
const _hoisted_2 = {
  id: "app",
  class: "flex w-full h-screen justify-center items-center"
}
const _hoisted_3 = {
  key: 0,
  class: "w-full max-w-xl p-3"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "font-bold text-3xl text-center text-indigo-700" }, " Create Assessment ", -1))
const _hoisted_5 = { class: "bg-white p-12 rounded-lg shadow-lg w-full mt-8" }
const _hoisted_6 = { id: "assessment-code-outer" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Choose the Assessment Type:", -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["value"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"margin-top":"15px"} }, "Enter the Client Name:", -1))
const _hoisted_11 = {
  key: 0,
  class: "warning-container"
}
const _hoisted_12 = { class: "warning" }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "orbit-spinner" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "orbit" }),
  /*#__PURE__*/_createElementVNode("div", { class: "orbit" }),
  /*#__PURE__*/_createElementVNode("div", { class: "orbit" })
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Creating Assessment...", -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  class: "w-full max-w-xl p-3"
}
const _hoisted_18 = { class: "font-bold text-3xl text-center text-indigo-700" }
const _hoisted_19 = { class: "access-code" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RingLoader = _resolveComponent("RingLoader")!

  return (_openBlock(), _createElementBlock("body", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.sessionCreated == false)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                (_ctx.questionnaires.length == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Loading Assessments..."))
                  : _withDirectives((_openBlock(), _createElementBlock("select", {
                      key: 1,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.questionnaire_id) = $event))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionnaires, (questionnaire) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: questionnaire.id,
                          value: questionnaire.id
                        }, _toDisplayString(questionnaire.title), 9, _hoisted_9))
                      }), 128))
                    ], 512)), [
                      [_vModelSelect, _ctx.questionnaire_id]
                    ]),
                _hoisted_10,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.username) = $event)),
                  type: "text"
                }, null, 512), [
                  [_vModelText, _ctx.username]
                ])
              ])
            ]),
            (_ctx.warning != undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.warning), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.loading == true)
              ? (_openBlock(), _createBlock(_component_RingLoader, {
                  key: 1,
                  class: "loader",
                  color: '#54f1d2'
                }))
              : _createCommentVNode("", true),
            (_ctx.loading == true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16))
              : (_openBlock(), _createElementBlock("button", {
                  key: 3,
                  ref: "createaButton",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.createClicked && _ctx.createClicked(...args))),
                  class: "block mt-4 rounded-lg py-2 px-6 text-lg hover:bg-gray-100 cursor-pointer next-button"
                }, "Create", 512))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("h1", _hoisted_18, [
              _createTextVNode(" Assessment successfully created. Please use the code: "),
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.access_code), 1),
              _createTextVNode(" to begin the assessment. ")
            ])
          ]))
    ])
  ]))
}